import React from 'react'
import { useOfferionTranslation } from '../../shared/store/hooks/useOfferionTranslation'
import { useUserStore } from '../../shared/store/userStore'
import { UserModel } from '../../shared/models'
import { UsersApi } from '../../services/UsersApi'
import { UserForm } from '../settings/users/UserForm'

export const Footer = () => {
    const date = new Date()
    const userState = useUserStore(state => state.user)
    const { t } = useOfferionTranslation()
    // when user is set, we should show the user edit form
    const [user, setUser] = React.useState<UserModel | null>(null)

    const editUser = () => {
        UsersApi.get(userState.UserId).then(setUser)
    }

    const upsertUser = async (user: UserModel & { newPassword: string; sendEmail: boolean }) => {
        await UsersApi.upsertUser(user)
        setUser(null)
    }

    return (
        <footer className="footer">
            <div className="footer__content">
                <span className="footer__copyright">
                    {t('Footer.copyright', { currentYear: date.getFullYear() })}{' '}
                    {userState && userState.authenticated ? (
                        <span
                            className={user ? 'inline-block overlay__item overlay__item--active overlay__item--right-top' : 'inline-block'}
                        >
                            <span className="inline-block clickable clickable--underline" onClick={editUser}>
                                ({userState.Email})
                            </span>
                            {user && (
                                <div>
                                    <UserForm closeOverlay={() => setUser(null)} user={user} onSubmit={upsertUser} />
                                </div>
                            )}
                        </span>
                    ) : null}
                </span>
                <div className="footer__nav">
                    <ul>
                        <li dangerouslySetInnerHTML={{ __html: t('Footer.privacyPolicy') }}></li>
                        {/* @ts-ignore */}
                        <li className="footer-link" onClick={() => window.Userback.open()}>
                            {t('Footer.helpString')}
                        </li>
                        <li dangerouslySetInnerHTML={{ __html: t('Footer.termsOfService') }}></li>
                    </ul>
                </div>
            </div>
        </footer>
    )
}
